<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <div v-if="loadingWorkflow" key="loadingWorkflow" class="w-100 h-100 min-height-400">
            <busy-spinner text="Loading reports..."></busy-spinner>
        </div>

        <div v-else-if="!loadingWorkflow && !!carTask" key="hasCarTask" class="row h-100 pb-5">
            <div class="col-3 flex-shrink-1">
                <h4 class="text-right">Corrective<br>Action<br>Report</h4>
            </div>
            <div class="col-9">
                <!-- <car-pdf
                    title="Corrective Action Report"
                    :task-id="carTask.id"
                    class="max-width-800"
                ></car-pdf> -->
                <workflow-form-formio
                    :task-id="carTask.id"
                    display-mode="report"
                ></workflow-form-formio>
            </div>
        </div>

        <div v-else key="noCarTask" class="d-flex justify-content-between align-items-center">
            <h4 class="text-muted mb-0">No reports to show</h4>
        </div>
    
    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service';

export default {
    name: 'WorkflowReports',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        workflowRunId: {
            type: String,
            required: true,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingWorkflow: false,
            workflowRunData: null, 
            tasksList: null,  
        }
    },
    computed: {
        carTask() {  // if we have a complete_car task, we output it here (only first one)
            const allTasks = this.tasksList ?? [];
            if (allTasks) {
                return allTasks.find(t => t.key === 'complete_car');
            } else {
                return null;
            }
        },
    },
    mounted() {
        this.getWorkflowRunData();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getWorkflowRunData() {
            this.loadingWorkflow = true;
            try {
                // fetches the schema and any existing submissions for this task from our backend
                // NEW - with { workflow_run, tasks } in data - get_overview is all you need here -- you'll get details in other component
                const { data } = await suppliosApi.workflowRun.get_overview(this.workflowRunId);
                this.workflowRunData = Object.assign({}, data.workflow_run);
                this.tasksList = data.tasks;
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingWorkflow = false;
        },
    }
}
</script>

<style>

</style>